import axios from "axios";

const httpRequest = async (method, url, data = null, headers = {}) => {
  // axios.defaults.withCredentials = true;

  try {
    let response;
    if (method === "get") {
      response = await axios.get(url, { params: data, headers });
    } else if (method === "post") {
      response = await axios.post(url, data, { headers });
    } else if (method === "fetch") {
      response = await axios.fetch(url, data, { headers });
    } else if (method === "delete") {
      response = await axios.delete(url, { headers });
    } else {
      throw new Error("유효하지 않는 Method 입니다.");
    }
    return response.data;
  } catch (error) {
    if (error.response?.status === 401 || error.response?.status === 403 || error.response?.status === 500) {
      // 다시 로그인 하세요. 메시지가 포함된 경우, '/' 경로로 리다이렉션
      alert("다시 로그인을 진행해주세요.");
      window.location.href = "/logout";
    } else {
      // 그렇지 않은 경우, 콘솔에 에러를 출력
      console.log(error);
    }
  }
};

export default httpRequest;
